<template>
  <div @click="isCalendarShow = false">
    <div class="content ct1" v-show="chooseFileList.length == 0" @drop="drop($event)" @dragenter="dragenter($event)" @dragover="dragover($event)">
      <label>
        <input type="file" name="fileUp" id="" class="file" multiple @change="fileChange" accept="image/jpg,image/png,image/jpeg,image/gif,image/tiff,image/webp" :disabled="!isStateCheck" />
        <div class="text" :class="{ active: !isStateCheck }" @click="showWarnText">
          批量上传图片素材
        </div>
      </label>
      <p class="font1">点击 / 拖拽一个或多个文件到这里上传</p>
      <p class="font2">支持jpg、jpeg、png、gif等图片格式</p>
      <div class="warn">
        温馨提醒：
        <div class="check">
          <input type="checkbox" name="warn" v-model="isStateCheck" />
        </div>
        用户第一次上传请认真阅读
        <span style="cursor: pointer" @click.stop="stateIndex = 1">《版权声明》</span><span style="cursor: pointer" @click.stop="stateIndex = 2">《上传声明》</span>
      </div>
    </div>
    <div class="content ct2" v-show="chooseFileList.length > 0" @click="closeWarn">
      <h3>图片信息</h3>
      <div class="item" v-for="(item, index) in fileShareList" :key="index" :id="'img' + index">
        <div class="ct2-left fl">
          <label>
            <img :src="item.src" alt="" class="left-img" :title="item.Title" @load="getSizeByIndex($event, index)" />
            <!--<label v-show="!item.isImg">
                        <input type="file" class="file" @change="upCoverimg($event,index)" accept="image/jpg,image/png,image/jpeg,image/gif,image/tiff,image/webp"/>
                        <div class="df left-up">
                            <div>
                                <div class="add">+</div>
                                <p>上传封面</p>
                            </div>
                            <div class="ft12">
                                <p>只支持JPG/PNG，大小不超过5M</p>
                                <p>建议尺寸为800X600</p>
                            </div>
                        </div>
                    </label>-->
          </label>
          <!--<p class="left-nece">请上传封面</p>-->
        </div>
        <div class="ct2-right clearfix">
          <div class="input-box necessary">
            <input type="text" placeholder="请输入图片名称" v-model="item.Title" />
            <div class="nece-text" v-show="isSend && item.Title == ''">
              <span class="warn-icon">!</span> 必填项
            </div>
          </div>
          <div class="input-box necessary category">
            <input type="text" placeholder="请选择文件所属分类" :value="item.CategoryText" class="arr-down" readonly />
            <div class="nece-text" v-show="isSend && item.MediumCategoryID == 0">
              <span class="warn-icon">!</span> 必填项
            </div>
            <div class="nece-text">
              <div class="copy_btn label" @click="cloneItem('CategoryText', item.CategoryText, index)">
                复制
              </div>
            </div>
            <ul class="down-menu menu1" v-show="true">
              <li v-for="(item, index1) in BelongDirecotrys" :key="index1" :id="item.Id">
                <p v-text="item.Name"></p>
                <ul class="menu2" v-if="item.Children && item.Children.length > 0">
                  <li v-for="(item1, index1) in item.Children" :key="index1" :id="item1.Id" :class="{
                      active: item1.Children && item1.Children.length == 0,
                    }" @click="
                      chooseCategory(
                        item1.Children && item1.Children.length == 0,
                        item.Name,
                        item1.Name,
                        '',
                        item.Id,
                        item1.Id,
                        '',
                        index
                      )
                    ">
                    <p v-text="item1.Name"></p>
                    <ul class="menu3" v-if="item1.Children && item1.Children.length > 0">
                      <li v-for="(item2, index2) in item1.Children" :key="index2" :id="item2.Id" class="active" @click="
                          chooseCategory(
                            true,
                            item.Name,
                            item1.Name,
                            item2.Name,
                            item.Id,
                            item1.Id,
                            item2.Id,
                            index
                          )
                        ">
                        <p v-text="item2.Name"></p>
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
          <!--分类说明-->
          <div class="input-box cate-explain" v-if="cateExplain" v-text="cateExplain"></div>
          <!--标签列表-->
          <Labels :localLabels="localLabels" :DailyLabels="commonLabelList" :SystemLabels="item.systemLabelList" :HotLabels="hotLabelList" :obj="item">
          </Labels>
          <div class="cate-box">
            <div class="cate-item" v-for="(item, index) in categoryList" :key="index">
              <span>{{ item.type }}：</span>
              <label v-for="(item1, index) in item.value" :key="index" class="check">
                <input type="checkbox" :name="item.type" :value="item1" />
                {{ item1 }}
              </label>
            </div>
          </div>
          <div v-if="item.MediumCategoryID && item.MediumCategoryID != 0">
            <div class="input-box necessary">
              <span class="fl">版权所有：</span>
              <select class="cpr-box arr-down1" v-model="item.CopyrightAllID" @change="getCprDetail($event, index)">
                <option value="0" selected>请选择</option>
                <option v-for="(eve, index1) in item.copyRightListOption" :key="index1" :value="eve.Id">
                  {{ eve.CopyrightConent }}
                </option>
              </select>
              <div class="nece-text" v-if="isSend && item.CopyrightAllID == 0">
                <span class="warn-icon">!</span> 必填项
              </div>
              <div class="nece-text" v-else>
                <div class="copy_btn label" @click="
                    cloneItem('CopyrightAllID', item.CopyrightAllID, index)
                  ">
                  复制
                </div>
              </div>
            </div>
            <div v-if="item.CopyrightAllID != 0">
              <div class="input-box necessary">
                <span class="fl">版权用途：</span>
                <select class="cpr-box arr-down1" v-model="item.CopyrightLimitID">
                  <option value="0" selected>请选择版权用途</option>
                  <option v-for="(item, index) in item.cprLimitList" :key="index" :value="item.Id">
                    {{ item.CopyrightConent }}
                  </option>
                </select>
                <div class="nece-text" v-if="isSend && item.CopyrightLimitID == 0">
                  <span class="warn-icon">!</span> 必填项
                </div>
                <div class="nece-text" v-else>
                  <div class="copy_btn label" @click="
                      cloneItem(
                        'CopyrightLimitID',
                        item.CopyrightLimitID,
                        index
                      )
                    ">
                    复制
                  </div>
                </div>
              </div>
              <div>
                <div class="input-box necessary">
                  <span class="fl">版权来源：</span>
                  <select class="cpr-box arr-down1" v-model="item.CopyrightSourceID">
                    <option value="0" selected>请选择版权来源</option>
                    <option v-for="(item, index) in item.cprSourceList" :key="index" :value="item.Id">
                      {{ item.CopyrightConent }}
                    </option>
                  </select>
                  <div class="nece-text" v-if="isSend && item.CopyrightSourceID == 0">
                    <span class="warn-icon">!</span> 必填项
                  </div>
                  <div class="nece-text" v-else>
                    <div class="copy_btn label" @click="
                        cloneItem(
                          'CopyrightSourceID',
                          item.CopyrightSourceID,
                          index
                        )
                      ">
                      复制
                    </div>
                  </div>
                </div>
                <!-- 判断条件为版权来源Id,可能会更改,根据版权来源内容为 专业授权摄影 而来 -->
                <div v-if="item.CopyrightSourceID == 9">
                  <div class="input-box necessary">
                    <span class="fl">授权文件：</span>
                    <label class="cpr-box">
                      <input type="file" name="" id="" class="file" @change="chooseAuthorizeFile($event, index)" />
                      <div class="impower-file">
                        {{ item.AuthorizeName || "请上传授权文件" }}
                      </div>
                      <!--<input type="text" class="cpr-box" readonly placeholder="请上传授权文件" :value="item.AuthorizeName" />-->
                    </label>
                    <div class="nece-text" v-if="
                        isSend &&
                        (!item.AuthorizeName || item.AuthorizeName == '')
                      ">
                      <span class="warn-icon">!</span> 必填项
                    </div>
                    <div class="nece-text" v-else>
                      <div class="copy_btn label" @click="
                          cloneItem('AuthorizeName', item.AuthorizeName, index)
                        ">
                        复制
                      </div>
                    </div>
                  </div>
                  <div class="input-box calendar necessary">
                    <span class="fl">授权时间：</span>
                    <input type="text" @click.stop="openByDialog(index)" v-model="item.AuthorizeTime" placeholder="无" />
                    <transition name="fade">
                      <div class="calendar-box" v-show="isCalendarShow && nowIndex == index">
                        <!-- 日期组件 -->
                        <Calendar :range="calendar.range" :zero="calendar.zero" :lunar="calendar.lunar" :value="calendar.value" @select="calendar.select"></Calendar>
                      </div>
                    </transition>
                    <div class="nece-text" v-if="isSend && !item.AuthorizeTime">
                      <span class="warn-icon">!</span> 必填项
                    </div>
                    <div class="nece-text" v-else>
                      <div class="copy_btn label" @click="
                          cloneItem('AuthorizeTime', item.AuthorizeTime, index)
                        ">
                        复制
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 判断条件为版权来源Id,可能会更改,根据版权来源内容为 免费版权网站 而来 -->
                <div class="input-box necessary" v-if="item.CopyrightSourceID == 11">
                  <span class="fl">素材来源：</span>
                  <input type="text" placeholder="请输入素材来源的网站链接" class="cpr-box" v-model="item.ImgUrl" />
                  <div class="nece-text" v-if="isSend && item.ImgUrl == ''">
                    <span class="warn-icon">!</span> 必填项
                  </div>
                  <div class="nece-text" v-else>
                    <div class="copy_btn label" @click="cloneItem('ImgUrl', item.ImgUrl, index)">
                      复制
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="delete-item" @click.stop="deleteItem(index)">删 除</div>
          <create-thumb :setting="item.thumbSetting" v-show="item.thumbSetting && item.thumbSetting.img" @getThumb="getThumb" :ref="'thumb' + index"></create-thumb>
          <create-thumb :setting="item.detailSetting" v-show="item.detailSetting && item.detailSetting.img" @getThumb="getThumb" :ref="'detail' + index"></create-thumb>
          <!--<img :src="item.CoverImg" /> 
                <img :src="item.DetailImg"/>-->
        </div>
      </div>
      <div class="up-btn" @click.stop="sendPhotos">全部图片上传</div>
    </div>

    <Warn ref="warn"></Warn>
    <!-- 确认框 -->
    <Confirm ref="confirm" @handelConfirm="handelConfirm"></Confirm>
    <Uploader ref="uploader" :class="{ active: uploaderOption.isProgress }" :isUploaderShow="uploaderOption.isUploaderShow" :isDropShow="uploaderOption.isDropShow" :isPanelShow="uploaderOption.isPanelShow" :isSingleFile="uploaderOption.isSingleFile" :isOnlyImg="uploaderOption.isOnlyImg" :options="uploaderOption" @getFileName="getFileNameList" @closeUploader="closeUploader" @removeFile="removeFile" @fileSuccess="fileSuccess" @fileProgress="fileProgress" @fileError="fileError"></Uploader>
    <div class="dialog" v-show="stateIndex > 0" @click.stop="stateIndex = 0">
      <div class="model" @click.stop>
        <div class="mo-close" @click.stop="stateIndex = 0">×</div>
        <div v-show="stateIndex == 2">
          <h3 class="mo-title">上传声明</h3>
          <p class="no-indent">华强方特图库网郑重提醒您:</p>
          <p>
            为响应国家九部委联合开展深入整治互联网和手机媒体淫秽色情及低俗信息专项行动的号召，营造一个健康文明的网络环境，给大家一个和谐积极的家园。
          </p>
          <p class="no-indent">1、不得上传任何有违国家法律法规的内容。</p>
          <p class="no-indent">2、不得上传具有色情内容的内容。</p>
          <p class="no-indent">3、不得上传内容低俗，格调不高的内容。</p>
          <p class="no-indent">4、不得上传具有色情诱导性内容的内容。</p>
          <p class="no-indent">
            5、不得在标题、简介和标签中出现任何具有低俗色情含义的字眼。
          </p>
          <p class="no-indent">6、不得上传其他网站的精选版权作品。</p>
          <p class="no-indent">
            如果您上传了这些内容，我们将一律予以删除，请理解并监督我们。
          </p>
          <p>
            您使用华强方特图库网服务上传、发布或传输内容即代表了您有权且同意在全世界范围内，永久性的、不可撤销的、免费的授予华强方特图库网对该内容的存储、使用、发布、复制、发行、展览、网络传播、修改、改编、出版、翻译、据以创作衍生作品、传播、表演和展示等权利；将内容的全部或部分编入其他任何形式的作品、媒体、技术中的权利；对您的上传、发布的内容进行商业开发的权利；通过有线或无线网络向计算机终端、移动通讯终端（包括但不限于便携式通讯设备如手机和智能平板电脑等）、手持数字影音播放设备、电视接收设备（模拟信号接收设备、数字信号接收设备、数字电视、IPTV、带互联网接入功能的播放设备等）等提供信息的下载、数据传输、及其相关的宣传和推广等服务的权利；再授权给其他第三方以上述方式使用的权利；以及对作品进行单独维权的权利。
          </p>
        </div>
        <div v-show="stateIndex == 1">
          <h3 class="mo-title">版权声明</h3>
          <p>
            华强方特图库网根据用户指令提供作品上传、下载以及传播等，向来十分重视网络版权及其他知识产权以及用户权益的保护。
          </p>
          <p>
            华强方特图库网作为网络服务提供者，对非法转载，盗版行为的发生不具备充分的监控能力，如果您认为华强方特图库网用户通过华强方特图库网提供的信息存储空间所上载、传播的内容侵犯了您的相关权益的，请您向华强方特图库网发出权利通知，华强方特图库网将根据相关法律规定采取措施删除相关内容，您可以向华强方特图库网所设立的专门接受版权投诉和侵权通知的邮箱发送通知书。
          </p>
          <p>
            一旦收到符合上述要求之通知，我们将在合理时间内删除涉嫌侵权的作品。如不符合上述条件，我们会请阁下提供相应信息，且暂不采取包括删除等相应措施。
          </p>
          <h3 class="mo-title">关于授权图片</h3>
          <p>
            编辑用途图片：指被允许在新闻报道、出版发行、官方微博、微信等行为中使用，原作者及其供稿人仅拥有该图片的版权，不拥有画面内容中所涉及的任何人物的肖像权或实物的物权、知识产权等其他权利。该图片仅限制编辑报道用途，禁止用于一切商业推广用途。
          </p>
          <p>
            商业用途图片：指出于盈利的目的，将图片直接或修改后用于网络推广、广告、印刷等。
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script> 
import Labels from "../common/labels";
import Calendar from "../common/calendar/calendar.vue";
import Warn from "../common/warn";
import Confirm from "../common/confirm";
import CreateThumb from "../common/createThumb";
import {
  formateDate,
  getCss,
  dataUrlToFile,
  concat,
} from "../../assets/js/modules/utils";
import Uploader from "../common/uploader";
import {
  getArticalType,
  getCprInfo,
  getCprDetail,
  uploadePhoto,
  uploadCommonFile,
  getSystemLabels,
} from "@/assets/js/modules/shareApi";
import { GetFileForEdit } from "../../assets/js/modules/fileApi";
//文件对象
var File = function (Id, src, title, isImg, FileFormat, storageSize) {
  this.Id = Id; //图片Id
  this.FileNo = "";
  this.src = src;
  this.FileObjectKeyCacheKey = ""; //上传图片路径
  this.FileName = title; //文件名称
  this.CoverImg = "";
  this.DetailImg = "";
  this.CoverImgWidth = 0;
  this.CoverImgHeight = 0;
  this.isImg = isImg; //是否为图片
  this.Title = title; //图片名称
  this.FileDetail = {
    FileNo: "",
    Size: "", //尺寸 例 200×200
    StorageSize: storageSize, //存储大小 MB
    FileType: 1, //文件类型 1--图片
    WebType: 1,
    FileFormat: FileFormat, //文件格式
  };
  this.Labels = []; //所属标签
  this.MediumCategoryID = "";
  this.CategoryText = ""; //类型显示文字
  this.LastCategoryIDs = "";
  this.CopyrightAllID = "0"; //版权所有
  this.CopyrightLimitID = "0"; //版权限制
  this.CopyrightSourceID = "0"; //版权来源
  this.AuthorizeFileObjectKeyCacheKey = ""; //授权文件
  this.AuthorizeName = ""; //授权文件名称
  this.AuthorizeTime = ""; //授权时间
  this.AuthorizeStartTime = "";
  this.AuthorizeEndTime = "";
  this.ImgUrl = ""; //原文链接
  this.systemLabelList = []; //系统标签
  this.cprLimitList = [];
  this.cprSourceList = [];
  this.trueSize = { width: 0, height: 0 }; //图片真实尺寸,用于生产详情图和缩略图
  this.thumbSetting = {
    index: -1,
    img: "",
    autoCropWidth: 0,
    autoCropHeight: 0,
  };
  this.detailSetting = {
    index: -1,
    img: "",
    autoCropWidth: 0,
    autoCropHeight: 0,
  };
};
export default {
  inject: ["reload"],
  components: {
    Calendar,
    Warn,
    Confirm,
    Uploader,
    CreateThumb,
    Labels,
  },
  data() {
    return {
      isStateCheck: true, //是否勾选
      labelNum: 10, //可贴标签最大数量
      maxLength: 10, //上传图片最大数量
      nowIndex: 0, //当前操作的一项的下标
      confirmValue: false, //确认值
      confirmType: -1, //确认框操作类型   1--删除一项, 2--全部图片上传, 3--关闭上传框
      chooseFileList: [], //选择上传文件列表
      fileShareList: [],
      BelongDirecotrys: [], //图片类型列表
      categoryText: "",
      categoryList: [], //分类列表
      cprOwnerList: [],
      isCalendarShow: false, //是否显示日历控件
      calendar: {
        display: formateDate() + "~" + formateDate(),
        range: true,
        zero: true,
        value: [
          [formateDate(1), formateDate(2), formateDate(3)],
          [formateDate(1), formateDate(2), formateDate(3)],
        ], //默认日期
        lunar: true, //显示农历
        select: (begin, end) => {
          this.calendar.value = [begin, end];
          this.calendar.display = begin.join("-") + " ~ " + end.join("-");
          this.fileShareList[this.nowIndex].AuthorizeStartTime = begin.join(
            "-"
          );
          this.fileShareList[this.nowIndex].AuthorizeEndTime = end.join("-");
          this.fileShareList[
            this.nowIndex
          ].AuthorizeTime = this.calendar.display;
          this.isCalendarShow = false;
        },
      },
      hotLabelList: [], //热门标签列表
      commonLabelList: [], //常用标签列表
      localLabels: [], //本地标签列表
      upNum: 0, //文件上传数量
      uploaderOption: {
        isUploaderShow: false,
        isDropShow: true,
        isPanelShow: true,
        isSingleFile: false,
        isProgress: false,
        isOnlyImg: true,
      },
      menuHeight: "", //动态改变下拉列表高度
      isSend: false,
      uploadProgress: "", //上传进度
      isFailed: false, //是否上传失败,
      isEdit: false, //是否是编辑,用于判断是否需要生成缩略图
      stateIndex: 0, //声明下标
      labelsShowNum: 5,
      cateExplain: "", //分类说明
      explainObj: {
        noRight:
          "注意：免版权素材是指免费无版权图片素材，即满足CC0协议，任何人免费下载图片用作任何用途。请确保你上传的图片素材符合此要求！（无版权图片网站说明所有作品授权CC0协议，表示作者已经放弃一切版权，作品可以被不加限制的引用、转载、二次改编、再发表、应用于商业用途，使用者可以不标示该创作的来源和作者。）",
      },
    };
  },
  created() {
    this.getQuery();
    this.getArticalType();
    this.getCprInfo();
  },
  computed: {
    //版权列表
    copyList() {

    }
  },
  methods: {
    cloneItem(type, value, index) {
      // console.log(this.fileShareList, index);
      this.fileShareList.map((item, num) => {
        if (
          type == "CopyrightAllID" &&
          this.fileShareList[index].MediumCategoryID != item.MediumCategoryID
        ) {
          //只能复制相同分类下的版权
          return;
        } else {
          item.cprLimitList = this.fileShareList[index].cprLimitList;
          item.cprSourceList = this.fileShareList[index].cprSourceList;
          this.$set(this.fileShareList[num], 'copyRightListOption', this.cprOwnerFilter(this.cprOwnerList, index))
        }
        item[type] = value;
        if (type == "CategoryText") {
          //重新设置MediumCategoryID
          item.MediumCategoryID = this.fileShareList[index].MediumCategoryID;
        }
      });
      this.$refs.warn.message("复制成功!");
    },
    //获取url参数,用于编辑
    getQuery() {
      if (this.$route.query.uid && this.$route.query.fileId) {
        let data = {
          FileNo: this.$route.query.fileId,
        };
        this.isEdit = true;
        GetFileForEdit(data).then((res) => {
          if (res.data.Success) {
            let file = res.data.Data;
            this.getNeedParams(file);
            this.chooseFileList.push(file);
          }
        });
      }
    },
    //编辑图片时获取必填的参数
    getNeedParams(file) {
      file.hotLabelShowNum = file.commonLabelShowNum = file.systemLabelShowNum = 5;
      file.src = file.CoverImg;
      file.CategoryText = file.FirstCategoryName
        ? file.FirstCategoryName +
        (file.SecondCategoryName ? ">" + file.SecondCategoryName : "") +
        (file.MediumCategory ? ">" + file.MediumCategory : "")
        : (file.SecondCategoryName ? file.SecondCategoryName : "") +
        (file.MediumCategory ? ">" + file.MediumCategory : "");
      getCprDetail({ CopytrightAllId: file.CopyrightAllID }).then((res) => {
        if (res.data.Success) {
          file.cprLimitList = res.data.Data.CopyrightLimits;
          file.cprSourceList = res.data.Data.CopyrightSources;
          if (file.AuthorizeStartTime && file.AuthorizeEndTime) {
            file.AuthorizeName = file.AuthorizeFileName;
            file.AuthorizeTime =
              file.AuthorizeStartTime.split(" ")[0] +
              "~" +
              file.AuthorizeEndTime.split(" ")[0];
          }
          this.fileShareList.push(file);
          //获取系统标签
          this.getSystemLabel(0, this.fileShareList[0].MediumCategoryID);
        }
      });
    },
    //获取类型和标签
    getArticalType() {
      let data = {
        BelongPage: 1,
        UserId: JSON.parse(localStorage.getItem("userInfo")).Id,
      };
      getArticalType(data).then((res) => {
        if (res.data.Success) {
          this.hotLabelList = res.data.Data.HotLabels;
          this.commonLabelList = res.data.Data.DailyLabels;
          this.BelongDirecotrys = res.data.Data.BelongDirecotrys;
          //console.log(this.BelongDirecotrys);
        }
      });
      //获取本地标签
      this.getLocalLabels();
    },
    //获取本地标签
    getLocalLabels() {
      this.localLabels =
        (localStorage.getItem("localLabels") &&
          localStorage.getItem("localLabels").split(" ")) ||
        [];
    },
    //统一改变下拉菜单高度(暂时没执行)
    changeMenuHeight() {
      let h = 0;
      let m1 = document.querySelector(".menu1");
      let m2s = document.querySelectorAll(".menu2");
      let m3s = document.querySelectorAll(".menu3");
      h = parseInt(getCss(m1, "height"));
      //console.log(h);
      for (let i = 0; i < m2s.length; i++) {
        if (h < parseInt(getCss(m2s[i], "height"))) {
          h = parseInt(getCss(m2s[i], "height"));
        }
      }
      for (let j = 0; j < m3s.length; j++) {
        if (h < parseInt(getCss(m3s[j], "height"))) {
          h = parseInt(getCss(m3s[j], "height"));
        }
      }
      this.menuHeight = h + "px";
    },
    //选择类型
    chooseCategory(flag, name1, name2, name3, id1, id2, id3, index) {
      if (flag) {
        let txt = "";
        txt += name1 ? name1 : "";
        txt += name2 ? ">" + name2 : "";
        txt += name3 ? ">" + name3 : "";
        this.nowIndex = index;
        this.fileShareList[index].CategoryText = txt;
        this.fileShareList[index].MediumCategoryID = id3 ? id3 : id2 ? id2 : id1 ? id1 : "";
        // let data = {MediumCategoryID: this.fileShareList[index].MediumCategoryID};
        // getSystemLabels(data).then(res=>{
        //     if(res.data.Success){
        //         this.fileShareList[index].systemLabelList = res.data.Data;
        //     }
        // })
        // console.log(111111111111);
        this.fileShareList[index].copyRightListOption = this.cprOwnerFilter(this.cprOwnerList, index)
        this.getSystemLabel(index, this.fileShareList[index].MediumCategoryID);
        this.resetItem(index);
      }
    },
    //获取系统标签
    getSystemLabel(index, mediumCategoryId) {
      let data = { MediumCategoryID: mediumCategoryId };
      getSystemLabels(data).then((res) => {
        if (res.data.Success) {
          this.$delete(this.fileShareList[index], "systemLabelList");
          // delete this.fileShareList[index].systemLabelList;
          // this.fileShareList[index].systemLabelList = res.data.Data;
          this.$set(
            this.fileShareList[index],
            "systemLabelList",
            res.data.Data
          );
        }
      });
    },
    //选择类型时重置该项,以防止传不必要的参数
    resetItem(index) {
      let list = this.fileShareList[index];
      list.CopyrightAllID = 0;
      list.AuthorizeStartTime = list.AuthorizeEndTime = list.AuthorizeTime = "";
      list.AuthorizeName = list.AuthorizeFileName = "";
      list.AuthorizeFileObjectKeyCacheKey = "";
      list.ImgUrl = "";
      let fileList = this.$refs.uploader.uploader.fileList;
      for (let i = 0; i < fileList.length; i++) {
        if (index == fileList[i].file.belongIndex) {
          this.$refs.uploader.uploader.fileList.splice(i, 1);
          return;
        }
      }
    },
    //获取版权所有
    getCprInfo() {
      getCprInfo().then((res) => {
        if (res.data.Success) {
          this.cprOwnerList = res.data.Data;
        }
      });
    },
    //根据版权所有Id获取版权相关信息
    getCprDetail(el, index) {
      console.log(index);
      let id = el.target.value;
      var that = this;
      if (id == 0) return;
      this.$delete(this.fileShareList[index], "cprLimitList");
      this.$delete(this.fileShareList[index], "cprSourceList");
      this.fileShareList[index].CopyrightLimitID = this.fileShareList[
        index
      ].CopyrightSourceID = 0;
      getCprDetail({ CopytrightAllId: id }).then((res) => {
        if (res.data.Success) {
          let cprLimits = res.data.Data.CopyrightLimits;
          let cprSource = res.data.Data.CopyrightSources;
          this.$set(that.fileShareList[index], "cprLimitList", cprLimits);
          this.$set(that.fileShareList[index], "cprSourceList", cprSource);

          //只有一个时值默认为第一个
          if (cprLimits.length == 1) {
            this.fileShareList[index].CopyrightLimitID = cprLimits[0].Id;
          }
          if (cprSource.length == 1) {
            this.fileShareList[index].CopyrightSourceID = cprSource[0].Id;
          }
        }
      });
    },
    //上传图片
    fileChange(el) {
      if (!el.target.files[0].size) return;
      if (el.target.files.length > this.maxLength) {
        //弹出提示,超出最大数量
        this.$refs.warn.message("一次性上传数量不能超过10个!");
        return;
      }
      this.fileList(el.target.files, el.target.files.length);
      el.target.value = "";
    },
    fileList(files, length) {
      for (let i = 0; i < length; i++) {
        this.fileAdd(files[i], length);
      }
    },
    //添加文件
    fileAdd(file, length) {
      var that = this;
      let text = "";
      let reader = new FileReader();
      this.$refs.warn.message("文件读取中...请稍等...", false);
      reader.readAsDataURL(file);
      reader.onload = function () {
        file.src = reader.result;
        file.isImg = that.testImg(file); //是否为图片
        that.upNum++;
        if (that.upNum == length) {
          that.$refs.warn.closeWarn();
        }
        if (!file.isImg) {
          text += file.name + "、<br/>";
          if (that.upNum == length) {
            //上传完成后
            that.upNum = 0;
            text += "不是图片格式,请选择正确的图片格式!";
            that.$refs.warn.message(text, false);
          }
          return;
        }
        file.FileFormat = file.name.substring(
          file.name.lastIndexOf(".") + 1,
          file.name.length
        );
        file.isOriginal = true; //用于辨别删除的是上传的素材还是授权文件,用于在移除文件时做判断
        that.chooseFileList.push(file);
        that.$refs.uploader.uploader.addFile(file);
        that.cloneObj(file);
      };
    },
    //检测是否为图片
    testImg(file) {
      let str = file.name
        .substring(file.name.lastIndexOf("."), file.name.length)
        .toLowerCase();
      var res = /\.(jpe?g|png|gif|webp|bmp|tiff|svg)/;
      if (res.test(str)) {
        return true;
      }
      return false;
    },
    //复制对象存入分享数组
    cloneObj(file) {
      var that = this;
      //let fileShare = Object.assign({},that.fileInfo);    //这会浅度复制对象,导致对象为引用类型的属性与被复制对象的内存地址相同
      let storageSize = (file.size / (1024 * 1024)).toFixed(2) + "MB";
      let fileShare = new File(
        null,
        file.src,
        file.name.substring(0, file.name.lastIndexOf(".")),
        file.isImg,
        file.FileFormat,
        storageSize
      );
      if (file.isImg) {
        fileShare.img = file.src; //图片路径
      }
      this.fileShareList.push(fileShare);
      fileShare = null;
    },
    //拖拽文件操作
    drop(el) {
      el.stopPropagation();
      el.preventDefault();
      if (!this.isStateCheck) return;
      if (el.dataTransfer.files.length > this.maxLength) {
        //弹出提示,超出最大数量
        this.$refs.warn.message("一次性上传数量不能超过10个!");
        return;
      }
      this.fileList(el.dataTransfer.files, el.dataTransfer.files.length);
    },
    dragenter(el) {
      el.stopPropagation();
      el.preventDefault();
    },
    dragover(el) {
      el.stopPropagation();
      el.preventDefault();
    },
    //获取图片尺寸
    getSizeByIndex(el, i) {
      if (this.isEdit) return;
      let w = el.target.naturalWidth;
      let h = el.target.naturalHeight;
      this.fileShareList[i].FileDetail.Size = w + "×" + h;
      this.fileShareList[i].trueSize = { width: w, height: h };
      this.createCoverImg(i);
      this.createDetailImg(i);
    },
    //生成封面图
    createCoverImg(i) {
      let list = this.fileShareList;
      if (!list[i].src) return;
      this.fileShareList[i].thumbSetting = {
        type: 1,
        index: i,
        img: list[i].src,
        autoCropWidth: 305,
        autoCropHeight:
          (305 / list[i].trueSize.width) * list[i].trueSize.height,
      };
    },
    //生成详情图
    createDetailImg(i) {
      let list = this.fileShareList;
      if (!list[i].src) return;
      this.fileShareList[i].detailSetting = {
        type: 2,
        index: i,
        img: list[i].src,
        autoCropWidth: 750,
        autoCropHeight:
          (750 / list[i].trueSize.width) * list[i].trueSize.height,
      };
    },
    //获取缩略图
    getThumb(data) {
      if (data.type == 1) {
        this.fileShareList[data.index].CoverImg = data.url;
        this.fileShareList[data.index].CoverImgWidth = data.width;
        this.fileShareList[data.index].CoverImgHeight = data.height;
        this.fileShareList[data.index].thumbSetting.img = "";
      } else if (data.type == 2) {
        this.fileShareList[data.index].DetailImg = data.url;
        this.fileShareList[data.index].detailSetting.img = "";
      }
    },
    //选择授权文件
    chooseAuthorizeFile(el, index) {
      if (!el.target.files[0]) return;
      let file = el.target.files[0];
      if (!file) return;
      let list = this.$refs.uploader.uploader.fileList;
      for (let i = 0; i < list.length; i++) {
        if (index == list[i].file.belongIndex) {
          this.$refs.uploader.uploader.removeFile(list[i]);
          break;
        }
      }
      this.fileShareList[index].AuthorizeName = file.name;
      file.isOriginal = false;
      file.belongIndex = index;
      this.$refs.uploader.uploader.addFile(file);
    },
    //更换封面图(前台用不上)
    upCoverimg(el, index) {
      var that = this;
      if (!el.target.files[0]) return;
      let file = el.target.files[0];
      if (!this.testImg(file)) {
        el.target.value = "";
        return;
      }
      let reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        that.fileShareList[index].src = reader.result; //更换封面图
        that.fileShareList[index].isImg = true;
      };
    },
    //删除一项
    deleteItem(index) {
      // let id = 'img'+index;
      // document.getElementById(id).scrollIntoView(true);
      //弹出确认框
      this.confirmType = 1; //表示当前为删除操作
      this.$refs.confirm.openConfirm("你确定要删除此项吗?");
      this.nowIndex = index;
    },
    //删除对应项的授权文件
    deleteAuthorizeFile(index) {
      let list = this.$refs.uploader.uploader.fileList;
      for (var i = 0; i < list.length; i++) {
        if (index == list[i].file.belongIndex) {
          this.$refs.uploader.uploader.removeFile(list[i]);
          break;
        }
      }
      //移除一项时改变后面授权文件的所属下标，防止再删除一项时导致授权文件错位
      for (let j = index; j < list.length; j++) {
        if (list[j].file.belongIndex || list[j].file.belongIndex == 0) {
          this.$refs.uploader.uploader.fileList[j].file.belongIndex--;
        }
      }
    },
    //打开日期选择框
    openByDialog(index) {
      this.nowIndex = index;
      this.isCalendarShow = true;
    },
    //显示更多热门标签
    showMoreLabel(type, index) {
      if (type == 1) {
        this.fileShareList[index].hotLabelShowNum = this.hotLabelList.length;
      } else if (type == 2) {
        this.fileShareList[
          index
        ].commonLabelShowNum = this.commonLabelList.length;
      } else if (type == 3) {
        this.fileShareList[index].systemLabelShowNum = this.fileShareList[
          index
        ].systemLabelList.length;
      } else if (type == 4) {
        this.fileShareList[index].localLabelShowNum = this.localLabels.length;
      }
      this.nowIndex = index;
    },
    //收起热门标签
    showLessLabel(type, index) {
      if (type == 1) {
        this.fileShareList[index].hotLabelShowNum = 5;
      } else if (type == 2) {
        this.fileShareList[index].commonLabelShowNum = 5;
      } else if (type == 3) {
        this.fileShareList[index].systemLabelShowNum = 5;
      } else if (type == 4) {
        this.fileShareList[index].localLabelShowNum = 5;
      }
      this.nowIndex = index;
    },
    //关闭提示框
    closeWarn() {
      this.$refs.warn.closeWarn();
    },
    //confirm 操作, 取消返回false,确认返回true
    handelConfirm(data) {
      this.$refs.confirm.closeConfirm();
      this.confirmValue = data.handel;
    },
    //获取上传文件列表名称
    getFileNameList(list) {
      if (!list || list.length == 0) return;
      this.uploaderOption.isUploaderShow = true;
      this.uploaderOption.isPanelShow = true;
    },
    fileSuccess(reses) {
      let res = reses[0];
      let file = reses[1];
      if (!file.file.belongIndex && file.file.belongIndex != 0) {
        //图片文件
        this.fileShareList[this.nowIndex].FileObjectKeyCacheKey = res.Data
          .IsUpLoaded
          ? res.Data.FileObjectCahcheKey
          : res.Data;
        if (this.findCprFileByIndex(this.nowIndex)) {
          this.$refs.uploader.uploader.fileList[
            this.findCprFileByIndex(this.nowIndex)
          ].resume();
        } else {
          this.nowIndex++;
          // this.uploadPhoto(this.nowIndex);
          this.uploadOtherPhoto(this.nowIndex);
        }
      } else if (
        this.findCprFileByIndex(this.nowIndex) ||
        this.findCprFileByIndex(this.nowIndex) == 0
      ) {
        //授权文件
        this.fileShareList[this.nowIndex].AuthorizeFileObjectKeyCacheKey = res
          .Data.IsUpLoaded
          ? res.Data.FileObjectCahcheKey
          : res.Data;
        this.nowIndex++;
        // this.uploadPhoto(this.nowIndex);
        this.uploadOtherPhoto(this.nowIndex);
      }
    },
    fileProgress(file) { },
    fileError() { },
    removeFile(file) {
      if (file.file.isOriginal) {
        //移除的素材文件
        let list = this.$refs.uploader.uploader.fileList;
        for (let i = 0; i < list.length; i++) {
          if (list[i].uniqueIdentifier === file.uniqueIdentifier) {
            this.deleteItem(i);
            this.$refs.confirm.openConfirm(
              "移除文件将会删除对应项,你确定要移除吗?"
            );
            return;
          }
        }
      } else {
        //移除授权文件
        let index = file.file.belongIndex || 0;
        this.$set(this.fileShareList[index], "AuthorizeName", "");
        // this.fileShareList[index].AuthorizeName = "请上传授权文件";
        this.$refs.uploader.uploader.removeFile(file);
      }
    },
    closeUploader() {
      if (this.$refs.uploader.uploader.fileList.length == 0) {
        this.uploaderOption.isPanelShow = this.uploaderOption.isUploaderShow = false;
        return;
      }
      this.confirmType = 3; //3--关闭上传框
      this.$refs.confirm.openConfirm(
        "关闭将会中断正在上传的文件以及取消上传将要上传的文件<br/>同时将会导致图片上传失败,你确定要关闭吗?"
      );
    },
    //过滤版权所有(注意: 会根据后台参数更改)
    cprOwnerFilter(arr, index) {
      let txt = this.fileShareList[index].CategoryText;
      if (!txt) return;
      if (txt.indexOf("免版权素材") != -1) {
        this.cateExplain = this.explainObj.noRight;
        return arr.filter((v, i) => {
          return (
            v.CopyrightConent.indexOf("无版权") != -1 ||
            v.CopyrightConent.indexOf("个人原创") != -1
          );
        });
      } else if (txt.indexOf("熊出没专题") != -1) {
        this.cateExplain = "";
        return arr.filter((v, i) => {
          return (
            v.CopyrightConent.indexOf("华强方特") != -1 ||
            v.CopyrightConent.indexOf("个人原创") != -1
          );
        });
      } else if (txt.indexOf("乐园专题") != -1) {
        this.cateExplain = "";
        return arr.filter((v, i) => {
          return (
            v.CopyrightConent.indexOf("华强方特") != -1 ||
            v.CopyrightConent.indexOf("个人原创") != -1
          );
        });
      }
      return arr;
    },
    //发布图片
    sendPhotos() {
      this.isSend = true;
      //判断必填项是否都填写完成
      if (this.justifyFiles()) {
        let progress = this.uploadProgress;
        this.$refs.warn.message(
          `请不要关闭当前页面，图片上传中<span class='animate-ellipse-box'><span class='animate-ellipse'>...</span></span>`,
          false
        );
        //开始上传图片和对应的授权文件(如果有的话),按顺序上传
        this.nowIndex = 0;
        //编辑图片并且没有更换授权文件
        if (
          this.fileShareList[this.nowIndex].FilePath &&
          this.fileShareList[this.nowIndex].FilePath.indexOf("http") === 0 &&
          this.$refs.uploader.uploader.fileList.length === 0
        ) {
          this.sendAll();
        } else {
          let list = this.$refs.uploader.uploader.fileList;
          for (let i = 0; i < list.length; i++) {
            if (list[i].isComplete()) {
              this.nowIndex++;
              continue;
            }
          }
          // this.uploadPhoto(this.nowIndex);
          this.uploadOtherPhoto(this.nowIndex);
        }
      }
    },
    justifyFiles() {
      let list = this.fileShareList;
      for (var i = 0; i < list.length; i++) {
        if (!this.justifyFile(list[i])) {
          this.$refs.warn.message("有必填项未填,请填写!");
          return false;
        }
      }
      return true;
    },
    justifyFile(file) {
      if (file.Title == "" || !file.MediumCategoryID) return false;
      if (!file.CopyrightAllID || file.CopyrightAllID == 0) return false;
      if (!file.CopyrightLimitID || file.CopyrightLimitID == 0) return false;
      if (!file.CopyrightSourceID || file.CopyrightSourceID == 0) return false;
      if (file.CopyrightSourceID == 9) {
        if (file.AuthorizeName == "") return false;
        if (!file.AuthorizeTime || file.AuthorizeTime == "") return false;
      } else if (file.CopyrightSourceID == 11) {
        if (!file.ImgUrl) return false;
      }
      return true;
    },
    //上传详情图和缩略图
    uploadOtherPhoto(index) {
      if (index > this.fileShareList.length - 1) {
        this.sendAll();
        return;
      }
      if (
        this.fileShareList[index].CoverImg.indexOf("http") == 0 &&
        this.fileShareList[index].DetailImg.indexOf("http") == 0
      ) {
        this.uploadPhoto(this.nowIndex);
        return;
      }
      let no = 0;
      let formData1 = new window.FormData();
      let formData2 = new window.FormData();
      formData1.append(
        "File",
        dataUrlToFile(
          this.fileShareList[index].CoverImg,
          this.fileShareList[index].FileName
        )
      );
      formData1.append(
        "FileExtension",
        this.fileShareList[index].FileDetail.FileFormat
      );
      formData1.append("UpLoadFileType", 2);
      formData2.append(
        "File",
        dataUrlToFile(
          this.fileShareList[index].DetailImg,
          this.fileShareList[index].FileName
        )
      );
      formData2.append(
        "FileExtension",
        this.fileShareList[index].FileDetail.FileFormat
      );
      formData2.append("UpLoadFileType", 1);
      uploadCommonFile(formData1).then((res) => {
        if (res.data.Success) {
          no++;
          this.fileShareList[index].CoverImg = res.data.Data;
          if (no >= 2) {
            this.uploadPhoto(this.nowIndex);
          }
        }
      });
      uploadCommonFile(formData2).then((res) => {
        if (res.data.Success) {
          no++;
          this.fileShareList[index].DetailImg = res.data.Data;
          if (no >= 2) {
            this.uploadPhoto(this.nowIndex);
          }
        }
      });
    },
    //上传图片并添加链接
    uploadPhoto(index) {
      if (this.$refs.uploader.uploader.fileList.length == 0) {
        this.sendAll();
        return;
      }
      if (this.$refs.uploader.uploader.fileList[index].isComplete()) {
        this.nowIndex++;
        this.uploadPhoto(this.nowIndex);
        return;
      }
      this.$refs.uploader.uploader.fileList[index].resume();
    },
    //发布所有
    sendAll() {
      this.nowIndex = 0;
      this.uploadPhotos(this.nowIndex);
    },
    //图片相关信息上传
    uploadPhotos(i) {
      this.uploadProgress =
        ((i / this.fileShareList.length) * 100).toFixed(2) + "%";
      if (i == this.fileShareList.length) {
        this.$refs.warn.message("所有图片上传成功!", false);
        setTimeout(() => {
          this.$router.push("/share/photo");
          this.reload();
        }, 1200);
        return true;
      }
      let data = {
        Id: this.fileShareList[i].Id || null,
        Title: this.fileShareList[i].Title,
        CoverImg: this.fileShareList[i].CoverImg,
        DetailImg: this.fileShareList[i].DetailImg,
        MediumCategoryID: this.fileShareList[i].MediumCategoryID,
        Labels: this.fileShareList[i].Labels,
        AuthorizeFileObjectKeyCacheKey:
          this.fileShareList[i].AuthorizeFileObjectKeyCacheKey || "",
        AuthorizeFileName: this.fileShareList[i].AuthorizeName,
        AuthorizeTime: this.fileShareList[i].AuthorizeTime,
        ImgUrl: this.fileShareList[i].ImgUrl,
        CopyrightAllID: this.fileShareList[i].CopyrightAllID,
        CopyrightLimitID: this.fileShareList[i].CopyrightLimitID,
        CopyrightSourceID: this.fileShareList[i].CopyrightSourceID,
        FileObjectKeyCacheKey:
          this.fileShareList[i].FileObjectKeyCacheKey || "",
        UserId: JSON.parse(localStorage.getItem("userInfo")).Id,
        FileDetail: this.fileShareList[i].FileDetail,
        CoverImgWidth: this.fileShareList[i].CoverImgWidth,
        CoverImgHeight: this.fileShareList[i].CoverImgHeight,
      };
      uploadePhoto(data)
        .then(
          (res) => {
            if (res.data.Success) {
              this.setLocalLabels(data.Labels);
            } else {
              //this.$refs.warn.message("图片上传失败,请重试!",false);
              this.isFailed = true;
              return;
            }
          },
          (err) => {
            //this.$refs.warn.message("图片上传失败,请重试!",false);
            this.isFailed = true;
            return;
          }
        )
        .then(() => {
          if (!this.isFailed) {
            i++;
            this.uploadPhotos(i);
          }
        });
    },
    findCprFileByIndex(index) {
      let list = this.$refs.uploader.uploader.fileList;
      for (var i = 0; i < list.length; i++) {
        if (index == list[i].file.belongIndex) {
          return i;
        }
      }
      return false;
    },
    showWarnText() {
      if (!this.isStateCheck) {
        this.$refs.warn.message("请阅读并勾选《版权声明》《上传声明》!");
      }
      return;
    },
    //设置本地标签
    setLocalLabels(list) {
      let arr = this.localLabels;
      arr = concat(arr, list);
      arr.splice(10, arr.length - 10 > 0 ? arr.length - 10 : 0);
      this.localLabels = arr;
      localStorage.setItem("localLabels", arr.join(" "));
    },
  },
  watch: {
    confirmValue: {
      handler: function () {
        if (this.confirmValue && this.confirmType == 1) {
          //确定删除图片
          this.chooseFileList.splice(this.nowIndex, 1);
          this.fileShareList.splice(this.nowIndex, 1);
          this.$refs.uploader.uploader.fileList.splice(this.nowIndex, 1);
          this.deleteAuthorizeFile(this.nowIndex);
          this.confirmValue = false;
        } else if (this.confirmType == 3) {
          //关闭上传框
          this.$refs.uploader.uploader.cancel();
          this.reload();
        }
      },
    },
    fileShareList: {
      handler: function () {
        var that = this;
        if (this.fileShareList.length == 0) {
          this.isSend = false;
        }
      },
    },
  },
  filters: {},
};
</script>
<style scoped>
.content {
  background-color: #fff;
}
.ct1 {
  position: relative;
  height: 405px;
  text-align: center;
}
.file {
  display: none;
  opacity: 0;
  filter: rgba(0, 0, 0, 0);
}
.text {
  display: inline-block;
  padding: 0 80px;
  height: 42px;
  line-height: 40px;
  border: 1px solid #ff9933;
  border-radius: 21px;
  color: #999;
  margin: 110px auto 0;
  transition: all 0.3s;
  cursor: pointer;
}
.text:hover {
  background-color: #ff9933;
  color: #fff;
}
.text.active {
  color: #aaa;
  border-color: #ddd;
  background-color: #f8f8f8;
}
.font1 {
  font-size: 14px;
  margin-top: 28px;
}
.font2 {
  font-size: 14px;
  color: #999;
  margin-top: 14px;
}
.warn {
  position: absolute;
  bottom: 30px;
  left: 0;
  right: 0;
  font-size: 12px;
  color: #999;
}
.warn span:hover {
  color: #6699ff;
  text-decoration: underline;
}
.ct2 input[type="checkbox"] {
  border-radius: 0;
}
.ct2 input[type="checkbox"]:checked::after {
  top: 21px;
}
.ct2 > h3,
.ct2 .item {
  padding-left: 30px;
}
.ct2 > h3 {
  height: 60px;
  line-height: 60px;
  color: #666;
  border-bottom: 1px solid #e7e7e7;
}
.item {
  padding: 30px 0;
  font-size: 14px;
  color: #999;
  border-bottom: 1px solid #e7e7e7;
}
.ct2-left {
  position: relative;
  width: 240px;
  min-height: 180px;
  height: 180px;
}
.left-img {
  display: block;
  max-width: 100%;
  max-height: 100%;
  margin: 0 auto;
}
.left-nece {
  position: absolute;
  bottom: -30px;
  line-height: 30px;
  color: #ff0000;
  display: none;
}
.delete-item {
  float: right;
  line-height: 32px;
  text-align: center;
  width: 90px;
  box-sizing: border-box;
  border: 1px solid #ff9933;
  border-radius: 16px;
  cursor: pointer;
  transition: all 0.3s;
}
.delete-item:hover {
  background-color: #ff9933;
  color: #fff;
}
.ct2-right {
  margin: 0 97px 0 260px;
  position: relative;
}
.input-box {
  height: 40px;
  line-height: 40px;
  margin-bottom: 15px;
  box-sizing: border-box;
  position: relative;
}
.cate-explain {
  line-height: 1.5;
  height: auto;
  text-align: justify;
}
.necessary {
  position: relative;
}
.necessary::before {
  position: absolute;
  left: -14px;
  content: "●";
  width: 5px;
  height: 5px;
  color: #ff0000;
}
.input-box > input,
.cpr-box {
  width: 100%;
  height: 100%;
  border: 1px solid #e7e7e7;
  border-radius: 5px;
  background-color: #f8f8f8;
  box-sizing: border-box;
  padding: 0 25px 0 15px;
}
.nece-text {
  position: absolute;
  right: -70px;
  top: 0;
  height: 100%;
  font-size: 12px;
  color: #ff0000;
}
.copy_btn {
  background: #6699ff !important;
  color: #fff;
  margin: 10px 0 !important;
}
.warn-icon {
  padding: 0 6.25px;
  border-radius: 50%;
  background-color: #ff0000;
  color: #fff;
}
.arr-down {
  background: url(../../assets/img/arr_down_icon.png) no-repeat right 25px
    center;
}
.arr-down1 {
  background: url(../../assets/img/arr_down_icon.png) no-repeat right 12px
    center;
}
.down-menu {
  position: absolute;
  left: 0;
  top: 40px;
  z-index: 2;
  line-height: 30px;
  border: 1px solid #e7e7e7;
  border-radius: 5px;
  background-color: #fff;
  cursor: default;
}
.down-menu ul {
  background-color: #fff;
  border: 1px solid #e7e7e7;
}
.down-menu ul li {
  padding: 0 20px 0 23px;
}
.down-menu li.active {
  cursor: pointer;
}
.down-menu li:hover {
  background-color: #6699ff;
  color: #fff;
}
.menu1 {
  width: 104px;
  text-align: center;
  display: none;
}
.menu2,
.menu3 {
  position: absolute;
  top: -1px;
  left: 100%;
  min-width: 144px;
  white-space: nowrap;
  text-align: left;
  color: #999;
  display: none;
}
.menu3 {
  height: 270px;
  overflow-y: scroll;
}
.menu3::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0px 20px 20px 13px rgb(243, 243, 243);
  box-shadow: inset 0px 20px 20px 13px rgb(243, 243, 243);
  background-color: #ccc;
}
.menu3::-webkit-scrollbar {
  width: 10px;
  background-color: #ccc;
}

.menu3::-webkit-scrollbar-thumb {
  background-color: #e1e1e1;
}
.category:hover .menu1 {
  display: block;
}
.menu1 > li:hover .menu2 {
  display: block;
}
.menu2 > li:hover .menu3 {
  display: block;
}
.labelling {
  position: absolute;
  right: 20px;
  top: 0;
  height: 100%;
}
.label-container {
  border-bottom: 1px solid #e7e7e7;
  -ms-user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;
  user-select: none;
}
.label-box,
.cate-box {
  margin-bottom: 15px;
}
.label-right {
  margin-left: 76px;
}
.label {
  line-height: 20px;
  height: 20px;
  padding: 0 12px;
  background-color: #e9e9e9;
  border-radius: 4px;
  margin: 0 10px 10px 0;
  cursor: pointer;
}
.label.active {
  background-color: #6699ff;
  color: #fff;
}
.label .close {
  display: inline-block;
  font-size: 20px;
  vertical-align: middle;
  margin-top: -5px;
}
.more-label,
.less-label {
  cursor: pointer;
}
.cate-box {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.cate-item {
  line-height: 48px;
  border-bottom: 1px solid #e7e7e7;
}
.cate-item .check {
  margin-left: 20px;
}
.input-box .cpr-box {
  -webkit-appearance: none;
  width: 480px;
  margin-left: 76px;
  display: block;
  color: #999;
  background-color: #f8f8f8;
}
.up-btn {
  width: 390px;
  height: 40px;
  line-height: 40px;
  border: 1px solid #ffcc99;
  border-radius: 20px;
  text-align: center;
  color: #999;
  margin: 45px auto;
  cursor: pointer;
  transition: all 0.3s;
}
.up-btn:hover {
  background-color: #ff9933;
  color: #fff;
}
.left-up {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  font-size: 14px;
  color: #999;
  cursor: pointer;
}
.ft12 {
  font-size: 12px;
  margin-top: 20px;
}
.add {
  width: 40px;
  height: 40px;
  line-height: 36px;
  border-radius: 50%;
  background-color: #ff9933;
  color: #fff;
  font-size: 36px;
  display: inline-block;
  margin-bottom: 5px;
}
.calendar {
  height: auto;
}
.cpr-box .impower-file {
  height: 100%;
}
.calendar input {
  width: 480px;
  margin-left: 76px;
  height: 40px;
  display: block;
}
.calendar-box {
  position: relative;
  z-index: 99;
  margin-left: 76px;
  width: 480px;
}
.calendar-box >>> .calendar {
  background: #f8f8f8;
}
.calendar-box >>> .calendar-tools {
  color: #333;
}
.calendar-box >>> .calendar-info > div.month,
.calendar-box >>> .calendar-info > div.year {
  color: #333;
}
.calendar-box >>> .calendar td.selected span {
  background-color: #ff9933;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s ease-in-out;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
  transform: translateY(-10px);
}
.dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  background: rgba(0, 0, 0, 0.6);
}
.model {
  position: absolute;
  top: 50%;
  left: 50%;
  margin: -400px 0 0 -30%;
  width: 60%;
  height: 800px;
  border-radius: 15px;
  box-sizing: border-box;
  background-color: #fff;
  padding: 30px;
  line-height: 2;
  color: #666;
  overflow-y: scroll;
}
.model::-webkit-scrollbar {
  width: 0;
}
.model h3 {
  font-size: 18px;
  font-weight: bold;
}
.model p {
  font-size: 16px;
  text-indent: 2em;
}
.model .no-indent {
  text-indent: 0;
}
.mo-close {
  position: absolute;
  right: 20px;
  top: 7px;
  font-size: 53px;
  line-height: 1;
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/share/sharephoto.vue